import Playable from './Playable'
import AnearVenue from './AnearVenue'

export default class PlayableVenue extends Playable {
  constructor(json_data, json_included) {
    super(json_data, json_included)
    this.venue = new AnearVenue(this.findIncluded(this.relationships['venue']), json_included)
  }
}
